import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CmsMailFormFieldComponent } from '../../../../../../core/model/cms.model';

@Injectable({ providedIn: 'root' })
export class CmsMailFormConnector {
  converterService: any;
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  /**
   * Post mailForm input fields to api
   * @param userId the user id
   * @param recaptchaKey the recaptcha key
   * @param fieldsJson the form data as json string
   * @param filesFormData files as formData
   */
  postCmsMailForm(
    userId: string,
    recaptchaKey: string,
    fieldsJson: string,
    filesFormData: FormData
  ): Observable<Array<CmsMailFormFieldComponent>> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.httpClient.post<any>(
      this.occEndpointsService.buildUrl('mailForm', {
        urlParams: {
          userId: userId,
        },
        queryParams: {
          recaptchaKey: recaptchaKey,
          fieldsJson,
        },
      }),
      filesFormData,
      { headers }
    );
  }
}
